import axios from "axios";
import {KEY} from "../ui/dealer/AuthForm";

export interface RequestLog {
    uid: string;
    container: string;
    executionTime: number;
    url: string;
    params: any;
    status: number;
    timestamp: Date;
}

// Global array to store request logs
export const requestLogs: RequestLog[] = [];

// Global variable to store latest X-Uid
let latestUid: string = '';

export const getLatestUid = () => latestUid;

const axiosHttp = axios.create({
    responseType: "json",
    baseURL: process.env.REACT_APP_ENDPOINT,
});

// Add response interceptor to capture headers and timing
axiosHttp.interceptors.request.use((config: any) => {
    config.metadata = {startTime: new Date().getTime()};
    return config;
});

axiosHttp.interceptors.response.use((response) => {
    const xUid = response.headers['x-uid'];
    const xContainer = response.headers['x-container'];
    const endTime = new Date().getTime();
    // @ts-ignore
    const executionTime = endTime - (response.config.metadata?.startTime || endTime);

    if (xUid) {
        latestUid = xUid;
    }

    const logEntry: RequestLog = {
        uid: xUid || '',
        container: xContainer || '',
        executionTime,
        url: response.config.url || '',
        params: response.config.params || response.config.data || {},
        status: response.status,
        timestamp: new Date()
    };
    requestLogs.push(logEntry);

    return response;
}, (error) => {
    return Promise.reject(error);
});

export default function fetchData(url: string, params: any = {}, method: string = 'GET') {

    params['__url__'] = window.location.pathname
    const customer = localStorage.getItem('customer');
    params['__is_auth__'] = customer ? JSON.parse(customer)?.id : false

    axiosHttp.defaults.headers.common['Request-Url'] = window.location.pathname
    axiosHttp.defaults.headers.common['Is-Auth'] = customer ? JSON.parse(customer)?.id : false

    switch (method) {
        case 'DELETE':
            return axiosHttp.delete(url).then(response => response.data);
        case 'PUT':
            return axiosHttp.put(url, params).then(response => response.data);
        case 'POST':
            return axiosHttp.post(url, params).then(response => response.data);
        case 'GET':
            return axiosHttp.get(url).then(response => response.data);
        default:
            return axiosHttp.post(url, params).then(response => response.data);
    }
}

export function fetchDataDealer(url: string, params: any = {}, method: string = 'GET') {

    params['__url__'] = window.location.pathname
    const dealer = localStorage.getItem(KEY);
    params['__dealer__'] = dealer ? JSON.parse(dealer) : null

    switch (method) {
        case 'DELETE':
            return axiosHttp.delete(url).then(response => response.data);
        case 'PUT':
            return axiosHttp.put(url, params).then(response => response.data);
        case 'POST':
            return axiosHttp.post(url, params).then(response => response.data);
        case 'GET':
            return axiosHttp.get(url).then(response => response.data);
        default:
            return axiosHttp.post(url, params).then(response => response.data);
    }
}